import * as React from 'react';

import RoomTypeDescriptionRepository from '../../repositories/RoomTypeDescriptionRepository';
import RoomTypeDescription from '../../models/RoomTypeDescription';

interface P {
    typename?: string;
    folding?: boolean;
}

export default class Amenities extends React.Component<P, { description: RoomTypeDescription }> {

    static contextTypes: React.ValidationMap<any> = {
        room_type_description_repository: React.PropTypes.object
    }

    context: { room_type_description_repository: RoomTypeDescriptionRepository };

    constructor( props: {}, context: any ) {
        super( props, context );

        this.state = { description: undefined };
    }

    componentDidMount() {
        this.find();
    }

    private find() {
        this.context.room_type_description_repository.
             findByTypeName( this.props.typename ).
             done( data => this.setState({ description: data }) );
    }

    render() {
        if ( !this.state.description )
            return null;

        return (
            <ul>
              { this.state.description.amenities.map((a, i) =>
                  !(this.props.folding && a.foldable) && (
                      <li key={ `am_${i}` }>{ a.description }</li>
                  )
                ) }
            </ul>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/rooms/Amenities.tsx
 **/